// extracted by mini-css-extract-plugin
module.exports = {"KioskMenuItem":"KioskMenuItem_KioskMenuItem__1PK5_","Content":"KioskMenuItem_Content__2Sfdx","Icon":"KioskMenuItem_Icon__3rq_h","Title":"KioskMenuItem_Title__kXwPs"};